module.exports = __webpack_public_path__ + "5c70b038dfb3024d992e44e6473e014a.patt";